module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "form-row"
  }, [_vm._m(0), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.showImg
    }
  }, [_vm._v(_vm._s(_vm.img_string))]), _vm._v("\n         \n    "), (this.$store.state.user.user.username == 'aaron') ? _c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": _vm.returnModify
    }
  }, [_vm._v("退回修正")]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-10"
  }, [_c('img', {
    staticClass: "car-image",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "bigpic",
      "src": "bigpic"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7dc519aa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin/TicketManagement/TicketShoulderCheckDetail.vue
// module id = 1515
// module chunks = 1